import React, { useEffect, useState } from 'react';
import MasterComponent from '../../../../../components/Forms';
import ShortListedConfig from '../../../../../entity/HRM/pre-onboarding/shortlistedConfig';
import { Button, Tag, Typography, Modal, Space, DatePicker, notification } from 'antd';
import { FormColumnConfig, MasterConfigs } from '../../../../../interfaces/entity';
import { useDispatch } from 'react-redux';
import { putData } from '../../../../../actions/developer';
import { constants } from '../../../../../constants/common';
import { EditOutlined, CloseOutlined, EyeOutlined, ReloadOutlined } from '@ant-design/icons'
import dayjs from 'dayjs';
import OfferLetterForm from './OfferLetterForm';
import { Document, Page } from 'react-pdf';
import { getData } from '../../../../../actions/apiCall';
import DrawerComponent from '../../../../../components/Forms/Drawer';
import DoccumentReport from '../pre-onboarding/doccumentReport';
import NextRoundModal from '../../tabs/Screening/modal';
import PdfView from '../../../../../components/custom/PDFView';

const OfferLetter = () => {
    const level = constants.PROFILE_STATUS.OFFER_GENRATE;
    const [candidateType, setCandidateType] = useState(null)
    const [id, setId] = useState(null)
    const dispatch = useDispatch();
    const [selected, setSelectedRow] = useState<any>({})
    const [selectedCandidate, setSelectedCandidate] = useState<any>([])

    const [OfferLetter, setOfferLetter] = useState(false)
    const [edit, setEdit] = useState(null)
    const [currentDoc, setCurrentDoc] = useState(null);
    const [pdfVisible, setpdfView] = useState(false);
    const [numPages, setNumPages] = useState<number | null>(null);
    const [nextRound, setNextRound] = useState(false)

    const OverriddenConfig: MasterConfigs = {
        ...ShortListedConfig,
        api: () => '/offer-letter',
        loadPagination: true,
        tableProps: {
            scroll: { x: 1300 },
            rowSelection: {
                ...ShortListedConfig.rowSelection,
                onChange: (selectedRowKeys, selectedRows) => {
                    setSelectedCandidate(selectedRows)
                },
            },
        },
        actions: [...ShortListedConfig.actions, selectedCandidate.length > 0 && { name: 'move to next', actionType: 'Add', onClick: () => onMoveToNext() }],
        getColumns: () => [
            ...ShortListedConfig.getColumns().filter((ele: any) => !['currentCTC', 'expectedCTC', 'experiance'].includes(ele.dataIndex)),
            level == constants.PROFILE_STATUS.OFFER_GENRATE && {
                title: 'Joining Date',
                key: '',
                dataIndex: '',
                width: 200,
                align: 'center',
                render: (text) => {
                    return <Space.Compact>
                        <DatePicker
                            onChange={(date, dateString) => onOfferedCTC(dateString, text, 'joiningDate')}
                            disabled={edit !== text._id}
                            value={text.joiningDate ? dayjs(text.joiningDate) : null}
                        ></DatePicker>
                        {edit !== text._id && <Button icon={<EditOutlined />} type='link' onClick={() => setEdit(text._id)}></Button>}
                        {edit == text._id && <Button icon={<CloseOutlined />} type='link' onClick={() => setEdit(null)}></Button>}
                    </Space.Compact>
                }
            },
            {
                title: 'Offerd CTC',
                key: '',
                dataIndex: '',
                width: 200,
                align: 'center',
                render: (text) => {
                    return <Typography.Title level={5} editable={{
                        onChange: (e) => onOfferedCTC(e, text),
                    }}>{text?.offeredCTC}</Typography.Title>
                }
            },
            {
                title: 'Offer Letter',
                key: '',
                dataIndex: '',
                width: 100,
                fixed: 'right',
                align: 'center',
                render: (text) => {
                    return text?.offerLetters?.offerLetterFile ? <Button type='link' icon={<EyeOutlined />} onClick={() => onViewPDF(text)}></Button> : 'Waiting'
                }
            },
            {
                title: 'Genrate',
                key: 'offerLetters',
                dataIndex: 'offerLetters',
                fixed: 'right',
                width: 150,
                render: (text, record) => {
                    if (text?.offerLetterGenrated) {
                        return <Space direction='horizontal'>
                            <Tag color='green'>Genrated</Tag>
                            <Button type='link' icon={<ReloadOutlined />} onClick={() => onGenrate(record)}></Button>
                        </Space>
                    } else {
                        return <Button type='link' onClick={() => onGenrate(record)}>Genrate</Button>
                    }
                }
            },
            {
                title: 'send',
                key: 'offerLetters',
                dataIndex: 'offerLetters',
                width: 100,
                fixed: 'right',
                render: (text) => {
                    if (text?.offerLetterSent) {
                        return <Tag color='green'>Sent</Tag>
                    } else {
                        return <Button type='link' onClick={() => onSend(text)}>Send</Button>
                    }
                }
            },
            {
                title: 'Documents',
                key: 'documents',
                dataIndex: 'documents',
                width: 120,
                fixed: 'right',
                render: (key, record) => {
                    return record?.form ? <Button icon={<EyeOutlined />} onClick={() => setId(record?._id)} /> : <Tag bordered={false}>No Documents</Tag>
                }
            }
        ].filter(Boolean) as FormColumnConfig[],
        getFormColumns: () => [
            ...ShortListedConfig.getFormColumns().map(ele => {
                if (ele.name == 'candidateType') {
                    return {
                        ...ele,
                        selectProps: {
                            onChange: (text) => {
                                setCandidateType(text);
                            }
                        }
                    }
                } else {
                    if (ele.name == "experiance") {
                        if (candidateType == 'Experience') {
                            return ele
                        } else {
                            return
                        }
                    } else {
                        return ele
                    }
                }
            }).filter(Boolean)
        ],
    };

    const onMoveToNext = () => {
        setNextRound(true)
    }

    const onOfferedCTC = async (text, item, type = 'offeredCTC') => {
        let payload;
        if (type == 'offeredCTC' && text != item.offeredCTC) {
            payload = { ...payload, offeredCTC: text }
        }
        if (type == 'joiningDate' && text != item.joiningDate) {
            payload = { ...payload, joiningDate: text }
        }
        if ((text != item.offeredCTC && type == 'offeredCTC') || (text != item.joiningDate && type == 'joiningDate')) {
            const resData = await dispatch(putData(ShortListedConfig.api() + '/' + level + '/' + item._id, payload));
            if (resData) {
                onRefresh()
                setEdit(null)
            }
        }
    }

    const onSend = async (text) => {
        const resData = await dispatch(getData(OverriddenConfig.api() + '/send/mail/' + text._id));
        if (resData.code == 200) {
            onRefresh()
            notification.success({ message: 'Offer letter has been sent' })
        } else {
            notification.error({ message: 'Failed to send offer letter' })
        }
    }

    const onRefresh = () => {
        dispatch({
            type: 'REFRESH_TABLE',
            refreshTable: true
        })
    }

    const onGenrate = (text) => {
        console.log(text)
        setSelectedRow(text)
    }

    useEffect(() => {
        if (selected && selected._id) {
            setOfferLetter(true)
        }
    }, [selected])

    const onViewPDF = (text) => {
        if (text && text.offerLetters && text.offerLetters.offerLetterFile) {
            setpdfView(true)
            setCurrentDoc(text.offerLetters.offerLetterFile)
        }
    }

    return <React.Fragment>
        <OfferLetterForm isVisible={OfferLetter} onClose={() => {
            setOfferLetter(false)
            setSelectedRow({})
        }} selected={selected} level={level} />
        <MasterComponent config={OverriddenConfig} />
        <NextRoundModal isVisible={nextRound} onClose={() => setNextRound(false)} selected={selectedCandidate} level={level} />
        <DrawerComponent
            title='Verify Doccuments'
            handleCancel={() => setId(null)}
            isView={true}
            loading={false}
            submitForm={() => { }}
            visible={id}
        >
            <DoccumentReport id={id} />
        </DrawerComponent>

        <Modal
            open={pdfVisible}
            footer={null}
            onCancel={() => setpdfView(false)}
            width="70%"
            centered
            title={'View PDF'}
        >
            <iframe src={process.env.FILE_URL + currentDoc} style={{ height: '80vh' }} />
        </Modal>
    </React.Fragment>
}


export default OfferLetter;
